import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Ob der Nutzer weniger Bewegung wünscht (§12).
 *
 * <p>Geteilt, weil die Regel nicht nur für CSS gilt: Diagramme und Zähl-Animationen laufen in
 * JavaScript und ignorieren `prefers-reduced-motion` von sich aus. Bei einer animierten Kennzahl
 * ist das mehr als Geschmack — während der Animation steht dort eine Zahl, die nicht stimmt.</p>
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(
    () => typeof window !== 'undefined' && !!window.matchMedia?.(QUERY).matches,
  );

  useEffect(() => {
    if (!window.matchMedia) return;
    const media = window.matchMedia(QUERY);
    const update = () => setReduced(media.matches);
    media.addEventListener('change', update);
    update();
    return () => media.removeEventListener('change', update);
  }, []);

  return reduced;
}
